import { getProvisioners, getRequestForAccessProvisionerPaginated } from "./provisioners";

const request = {
  provisioners: {
    getProvisioners,
    getRequestForAccessProvisionerPaginated,
  },
};

export { request };
